import styled from 'styled-components'

import FormFieldInput from '../FormFieldInput'
import Icon from '../../../components/Icon'

export const Input = styled(FormFieldInput)`
  input {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    padding-left: 45px;
  }
`
export const Calendar = styled(Icon)`
  margin-right: 1rem;
`
